import { environment } from "../../../environments/environment";

export const cdnUri = (path: string) => {
  return `${environment.cdnBase}/${path}`;
};
